/* eslint-disable no-useless-escape */
/* eslint-disable no-control-regex */
import {
  AbstractControl,
  FormArray,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export class CustomValidators {
  static atLeastOneRequired(controlGroup: FormGroup): ValidationErrors | null {
    const controls = controlGroup.controls;
    if (controls) {
      const atleastOneControlHasValue = Object.keys(controls).some(
        key => controls[key].value
      );
      if (!atleastOneControlHasValue) {
        return {
          atLeastOneRequired: {
            message: `At least one control of the form group should have a value`,
          },
        };
      }
    }
    return null;
  }

  static charsNotAllowed(control: AbstractControl): ValidationErrors | null {
    const regex = /[%<=*+/\\>^|&()"]+/;
    if (control.value && regex.test(control.value)) {
      return {
        charsNotAllowed: {
          message: ' Sono stati inseriti dei caratteri non ammessi.',
        },
      };
    }
    return null;
  }

  static atLeastOneCheckboxIsChecked(propToCheck: string): ValidatorFn {
    // Questa è la funzione validatrice che viene restituita
    return (formArray: FormArray): ValidationErrors | null => {
      if (!formArray || !formArray.controls) {
        return null;
      }

      // La logica per controllare se almeno un checkbox è selezionato
      const atLeastOneIsChecked = formArray.controls.some(
        (control: FormGroup) =>
          control.controls[propToCheck] && control.controls[propToCheck].value
      );

      // Se nessuno è spuntato, ritorna un oggetto di errore. Altrimenti, ritorna null (valido).
      return atLeastOneIsChecked ? null : { atLeastOneCheckboxIsChecked: true };
    };
  }

  static invalidCf(control: AbstractControl): ValidationErrors | null {
    if (control.value && control.value.length !== 16) {
      return {
        invalidCf: {
          message: 'Il Codice Fiscale deve essere lungo 16 caratteri',
        },
      };
    }
    const regex =
      /(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]/gim;
    if (control.value && !regex.test(control.value)) {
      return {
        invalidCf: { message: 'Codice Fiscale non valido' },
      };
    }
    return null;
  }

  static invalidEmail(control: AbstractControl): ValidationErrors | null {
    const regex =
      /(?:[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    if (control.value && !regex.test(control.value)) {
      return {
        invalidEmail: {
          message: 'Si prega di inserire un indirizzo mail valido.',
        },
      };
    }
    return null;
  }

  static invalidPec(control: AbstractControl): ValidationErrors | null {
    const regex =
      /(?:[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@((?:\w*.?pec(?:.?\w+)*)|(?:\w*.?peo(?:.?\w+)*)|(?:\w*.?cert(?:.?\w+)*)|(?:\w*.?legal(?:.?\w+)*)|(?:\w*.?raccomandata(?:.?\w+)*))/;
    if (control.value && !regex.test(control.value)) {
      return {
        invalidPec: {
          message: 'Si prega di inserire un indirizzo Pec valido.',
        },
      };
    }
    return null;
  }

  static invalidNumber(control: AbstractControl): ValidationErrors | null {
    if (control.value < 3 || control.value > 30) {
      return {
        invalidNumer: {
          message: 'Si prega di inserire un numero compreso da 3 a 30',
        },
      };
    }
    return null;
  }

  static invalidNumberDTO(control: AbstractControl): ValidationErrors | null {
    if (control.value < 3 || control.value > 30) {
      return {
        invalidNumer: {
          message: 'Si prega di inserire un numero compreso da 3 a 30',
        },
      };
    }
    return null;
  }

  static invalidPhoneNumber(control: AbstractControl): ValidationErrors | null {
    const regex =
      /^([+][0-9]{2})*(3)[2-9]{1}[0-9]{1}[0-9]{6,7}$|^(0)[0-9]{1}[0-9]{6,9}$|^(0)[0-9]{1}[0-9]{1}[0-9]{5,8}$|^(0)[0-9]{1}[0-9]{1}[0-9]{1}[0-9]{4,7}$|^(803)([0-9]{3})$|^(800)([0-9]{6})$|^(803)([0-9]{6})$/;
    if (control.value && !regex.test(control.value)) {
      return {
        invalidPhoneNumber: {
          message: 'Si prega di inserire un numero di telefono valido.',
        },
      };
    }
    return null;
  }

  static invalidName(control: AbstractControl): ValidationErrors | null {
    const regex = /^([A-Za-zàéèùòì_ \,\-\'])+$/;
    if (control.value && !regex.test(control.value)) {
      return {
        invalidName: {
          message: ' Sono stati inseriti dei caratteri non ammessi.',
        },
      };
    }
    return null;
  }

  static invalidFileSize(size: number): ValidatorFn {
    const validatorFn = (control: AbstractControl): ValidationErrors | null => {
      const file = control.value as File;
      if (file) {
        const invalidFile = file.size / 1024 / 1024 > size;
        if (invalidFile) {
          return {
            invalidFileSize: {
              message: `Il file non rispetta la dimensione massima consentita.`,
            },
          };
        }
      }
      return null;
    };
    return validatorFn;
  }

  static numbersOnlyValidator(message: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value && !/^[0-9]+$/.test(control.value)) {
        return {
          numbersOnly: { message: message },
        };
      }
      return null;
    };
  }

  static positiveNumbersValidator(message: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (
        control.value &&
        control.value !== -1 &&
        !/^[1-9]\d*$/.test(control.value)
      ) {
        return {
          positiveNumbersValidator: { message: message },
        };
      }
      return null;
    };
  }

  static uniqueNameValidator(array: { name: string }[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const name = control.value;
      const existingItem = array.find(item => item.name === name);
      if (existingItem) {
        return {
          uniqueName: { message: "Il nome è già presente nell'elenco" },
        };
      }
      return null;
    };
  }

  static noOnlyWhitespaceValidator(
    control: AbstractControl
  ): ValidationErrors | null {
    if (control.value && control.value.trim().length === 0) {
      return {
        noOnlyWhitespaceValidator: { message: 'Il campo non può essere vuoto' },
      };
    }
    return null;
  }

  static numbersOnlyValidatorFn(
    control: AbstractControl
  ): ValidationErrors | null {
    if (control.value && !/^[0-9]+$/.test(control.value)) {
      return {
        numbersOnlyValidatorFn: { message: 'Il campo non può avere lettere' },
      };
    }
    return null;
  }

  /**
   * Custom validator for the indirizzo formgroup.
   */
  static indirizzoValidator(
    group: FormGroup
  ): { [key: string]: boolean } | null {
    const via = group.get('via')?.value;
    const cap = group.get('cap')?.value;
    const comune = group.get('comune')?.value;
    const provincia = group.get('provincia')?.value;
    const nazione = group.get('nazione')?.value;
    const regione = group.get('regione')?.value;

    const filledFields = [via, cap, comune, provincia, nazione, regione].filter(
      v => !!v
    );

    if (filledFields.length > 0 && filledFields.length < 5) {
      return { domicilioIncomplete: true };
    }

    return null;
  }

  static domicilioRequiredWhenResidenzaExistsValidator: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const anagraficaForm = control as FormGroup;
    const residenza = anagraficaForm.get('residenza');
    const domicilio = anagraficaForm.get('domicilio');
    const checkEqualsDomicilio = anagraficaForm.get('checkEqualsDomicilio');

    if (!residenza || !domicilio || !checkEqualsDomicilio) {
      return null;
    }
    const residenzaIsFilledAndValid = residenza.valid;
    const isDomicilioSameAsResidenza = checkEqualsDomicilio.value === true;
    const domicilioIsInvalid = domicilio.invalid;

    if (
      residenzaIsFilledAndValid &&
      !isDomicilioSameAsResidenza &&
      domicilioIsInvalid
    ) {
      return { domicilioObbligatorio: true };
    }

    return null;
  };

  /**
   * Date-time validator.
   */
  static dateTimeValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const group = control as FormGroup;
      const dateStartCtrl = group.get('dateStart');
      const timeCtrl = group.get('time');

      if (
        !dateStartCtrl ||
        !timeCtrl ||
        !dateStartCtrl.value ||
        !timeCtrl.value
      ) {
        return null;
      }

      const selectedDate = new Date(dateStartCtrl.value);
      const selectedTime = new Date(timeCtrl.value);
      const combinedDateTime = new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate(),
        selectedTime.getHours(),
        selectedTime.getMinutes()
      );

      const now = new Date();
      const truncatedNow = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        now.getHours(),
        now.getMinutes()
      );

      if (combinedDateTime < truncatedNow) {
        return { dateTimeInPast: true };
      }

      return null;
    };
  }

  static geoGroupValidator: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const regione = control.get('regione')?.value;
    const provincia = control.get('provincia')?.value;
    const comune = control.get('comune')?.value;

    // Se almeno uno è valorizzato, controlliamo che lo siano tutti e tre
    if (regione || provincia || comune) {
      if (!regione || !provincia || !comune) {
        // Restituiamo un errore a livello di gruppo
        return { geoIncompleto: true };
      }
    }

    // Se sono tutti vuoti o tutti pieni, il gruppo è valido
    return null;
  };

  static geoGroupRequired: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const values = control.value;
    if (!values.regione && !values.provincia && !values.comune) {
      return { required: true };
    }
    return null;
  };

  static geoRequiredIfSiblingsSet: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const group = control.parent as FormGroup;
    if (!group) return null;

    const regione = group.get('regione')?.value;
    const provincia = group.get('provincia')?.value;
    const comune = group.get('comune')?.value;

    // Se almeno uno dei tre è compilato
    const isAnySet = !!regione || !!provincia || !!comune;

    // Se io (il controllo corrente) sono vuoto MA almeno uno degli altri è pieno
    if (isAnySet && !control.value) {
      return { required: true }; // Restituiamo l'errore standard 'required'
    }

    return null;
  };

  /**
   * Verifica che la struttura selezionata non sia già stata scelta in un altro pannello.
   * Da applicare al controllo `strutturaSelezionata` all'interno di ciascun gruppo struttura.
   */
  static strutturaUnica(control: AbstractControl): ValidationErrors | null {
    const struttureArray = control.parent?.parent as FormArray;
    if (!struttureArray) return null;
    const selectedId = control.value?.id;
    if (selectedId == null) return null;
    const count = struttureArray.controls.filter(
      g =>
        (g as FormGroup).get('strutturaSelezionata')?.value?.id === selectedId
    ).length;
    return count > 1
      ? { strutturaGiaSelezionata: { message: 'Struttura già selezionata' } }
      : null;
  }

  /**
   * Verifica che il ruolo selezionato non sia già presente nella stessa struttura.
   * Da applicare al controllo `ruolo` all'interno di ciascun gruppo ruolo.
   */
  static ruoloUnico(control: AbstractControl): ValidationErrors | null {
    const ruoliArray = control.parent?.parent as FormArray;
    if (!ruoliArray) return null;
    const selectedId = control.value?.id;
    if (selectedId == null) return null;
    const count = ruoliArray.controls.filter(
      g => (g as FormGroup).get('ruolo')?.value?.id === selectedId
    ).length;
    return count > 1
      ? {
          ruoloGiaSelezionato: {
            message: 'Ruolo già selezionato per questa struttura',
          },
        }
      : null;
  }

  /**
   * Verifica che il lavoro selezionato non sia già presente nella stessa struttura.
   * Da applicare al controllo `lavoroSelezionato` all'interno di ciascun gruppo lavoro.
   */
  static lavoroUnico(control: AbstractControl): ValidationErrors | null {
    const lavoriArray = control.parent?.parent as FormArray;
    if (!lavoriArray) return null;
    const selectedId = control.value?.id;
    if (selectedId == null) return null;
    const count = lavoriArray.controls.filter(
      g => (g as FormGroup).get('lavoroSelezionato')?.value?.id === selectedId
    ).length;
    return count > 1
      ? {
          lavoroGiaSelezionato: {
            message: 'Lavoro già selezionato per questa struttura',
          },
        }
      : null;
  }

  static indirizzoAutocompleteVerificato(
    control: AbstractControl
  ): ValidationErrors | null {
    const value = control.value as { cap?: string } | string | null;
    if (!value) return null;
    if (typeof value === 'string' || !value.cap) {
      return {
        indirizzoNonVerificato: {
          message: 'Seleziona un indirizzo dalla lista dei suggerimenti',
        },
      };
    }
    return null;
  }

  static maxTimeTodayValidator(dateControlName: string): ValidatorFn {
    return (timeControl: AbstractControl): ValidationErrors | null => {
      if (!timeControl || !timeControl.parent) return null;

      const form = timeControl.parent;
      const dateControl = form.get(dateControlName);
      const selectedDate = dateControl?.value;
      const selectedTime = timeControl.value;

      if (!selectedDate || !selectedTime) return null;

      const today = new Date();
      const selected = new Date(selectedDate);

      if (
        selected.getFullYear() === today.getFullYear() &&
        selected.getMonth() === today.getMonth() &&
        selected.getDate() === today.getDate()
      ) {
        const selectedDateTime = new Date(selected);
        selectedDateTime.setHours(
          selectedTime.getHours(),
          selectedTime.getMinutes(),
          0,
          0
        );

        if (selectedDateTime.getTime() > today.getTime()) {
          return { timeTooLate: true };
        }
      }

      return null;
    };
  }

  /**
   * Validates that `minControlName`'s value is strictly less than
   * `maxControlName`'s value on the same FormGroup (e.g. pressione minima/massima).
   * @return {ValidatorFn} producing `{ minMaxInvalid: true }` when invalid.
   */
  static minMaxValidator(
    minControlName: string,
    maxControlName: string
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const min = Number(control.get(minControlName)?.value);
      const max = Number(control.get(maxControlName)?.value);

      if (!min || !max) return null;

      return min < max ? null : { minMaxInvalid: true };
    };
  }

  static dataFineDopoDataInizio(
    control: AbstractControl
  ): ValidationErrors | null {
    const dataInizio = control.parent?.get('dataInizio')?.value;
    const dataFine = control.value;
    if (!dataInizio || !dataFine) return null;
    const start = new Date(dataInizio);
    const end = new Date(dataFine);
    if (isNaN(start.getTime()) || isNaN(end.getTime())) return null;
    return end < start
      ? {
          dataFineAntecedente: {
            message: 'La data fine non può essere antecedente alla data inizio',
          },
        }
      : null;
  }
}

import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export class ParentErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    _form: FormGroupDirective | NgForm | null
  ): boolean {
    const isControlInvalid = !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched)
    );

    const isParentInvalid = !!(
      control &&
      control.parent &&
      control.parent.hasError('nonUniqueAnagBe') &&
      (control.parent.dirty || control.parent.touched)
    );

    return isControlInvalid || isParentInvalid;
  }
}
